import {toCurrency, toPoints} from '@/shared/helpers'
import AddIcon from 'mdi-react/AddIcon';
import MinusIcon from 'mdi-react/MinusIcon';

export const TABLE_COLUMNS = [
  {
    id: 'expander',
    enableRowSpan: 1,
    Header: ({getToggleAllRowsExpandedProps, isAllRowsExpanded}) => (
      <span {...getToggleAllRowsExpandedProps()}>
            {isAllRowsExpanded ? 'Collapse All' : 'Expand All'}
          </span>
    ),
    Cell: ({row}) =>
      row.canExpand ? (
        <span
          {...row.getToggleRowExpandedProps({
            style: {
              paddingLeft: `${row.depth * 2}rem`,
            },
          })}
        >
              {row.isExpanded ? <MinusIcon className="chevron-expand"/> : <AddIcon className="chevron-expand"/>}
            </span>
      ) : null,
    width: 125
  },
  {
    Header: "Program Name",
    accessor: 'program_name',
    enableRowSpan: 1
  },
  {
    Header: "Last Name",
    accessor: 'recipientLastName',
  },
  {
    Header: "First Name",
    accessor: 'recipientFirstName',
  },
  {
    Header: "Jan",
    accessor: 'month1_value',
    Cell: ({ row, value }) => { return toCurrency(value); },
  },
  {
    Header: "Feb",
    accessor: 'month2_value',
    Cell: ({ row, value }) => { return toCurrency(value); },
  },
  {
    Header: "Mar",
    accessor: 'month3_value',
    Cell: ({ row, value }) => { return toCurrency(value); },
  },
  {
    Header: "Apr",
    accessor: 'month4_value',
    Cell: ({ row, value }) => { return toCurrency(value); },
  },
  {
    Header: "May",
    accessor: 'month5_value',
    Cell: ({ row, value }) => { return toCurrency(value); },
  },
  {
    Header: "Jun",
    accessor: 'month6_value',
    Cell: ({ row, value }) => { return toCurrency(value); },
  },
  {
    Header: "Jul",
    accessor: 'month7_value',
    Cell: ({ row, value }) => { return toCurrency(value); },
  },
  {
    Header: "Aug",
    accessor: 'month8_value',
    Cell: ({ row, value }) => { return toCurrency(value); },
  },
  {
    Header: "Sep",
    accessor: 'month9_value',
    Cell: ({ row, value }) => { return toCurrency(value); },
  },
  {
    Header: "Oct",
    accessor: 'month10_value',
    Cell: ({ row, value }) => { return toCurrency(value); },
  },
  {
    Header: "Nov",
    accessor: 'month11_value',
    Cell: ({ row, value }) => { return toCurrency(value); },
  },
  {
    Header: "Dec",
    accessor: 'month12_value',
    Cell: ({ row, value }) => { return toCurrency(value); },
  }
];
